import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/driver/$token")({
  head: () =>
    buildHead({
      title: "Driver Check-in | LohaLink",
      description: "Share your truck location for an active LohaLink consignment.",
      canonical: "/driver",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/DriverCheckin")),
});
